import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"
import { IScoring } from "./asset"

export class CheckboxOptionsVM extends CommonOptionVM {
  default_value?: boolean
  required?: boolean
  enable_score?: boolean
  scoring?: IScoring

  constructor(data: Partial<CheckboxOptionsVM> = {}) {
    super(data)
    this.default_value = data?.default_value ?? undefined
    this.required = data.required ?? undefined
    this.enable_score = data.enable_score ?? undefined
    this.scoring = this.enable_score ? {
      min_point: this.scoring?.min_point ?? 0,
      max_point: this.scoring?.max_point ?? null,
      scoring_weight: this.scoring?.scoring_weight ?? 1
    } : undefined
  }

  validateData() {
    const errors: any[] = []
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default CheckboxOptionsVM

